import React from 'react';

// Import required components
import { Heading } from '../../../components';

// Import Swiper core and required modules
import { Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import Campaign from '../../../components/Campaign/Campaign';
import campaigns from '../../../constants/campaigns';



const Campaigns = () => { 

  return (
    <section className='campaigns'>

      {/* Section heading */}
      <Heading title={'Our Campaigns'} subTitle={'Community Support'} />

      <Swiper

        modules={[Autoplay]} // Enable Autoplay feature
        spaceBetween={10} // Space between slides
        loop={true} // Enables Infinite Loop
        autoplay={{ delay: 4000, disableOnInteraction: false }} // Auto-scroll every 4 seconds

        // Responsive Breakpoints for Different Screen Sizes
        breakpoints={{
          450: { slidesPerView: 1 }, // 1 slide for small screens
          768: { slidesPerView: 2 }, // 2 slides for tablets
          991: { slidesPerView: 3 }, // 3 slides for larger screens
        }}

      >

        {/* Map over the campaigns array to render each campaign */}
        {campaigns.map((campaign) => { 
          return (
            <SwiperSlide key={campaign.id}>

              {/* Render individual Campaign component */}
              <Campaign campaign={campaign} />

            </SwiperSlide>
          );
        })}

      </Swiper>

    </section>
  )
}

export default Campaigns;